export const calendarWeekHeader = {
  Su: {
    en: 'Sun',
    ja: '日',
    zh_tw: '日',
    'zh-TW': '日',
  },
  Mo: {
    en: 'Mon',
    ja: '月',
    zh_tw: '一',
    'zh-TW': '日',
  },
  Tu: {
    en: 'Tue',
    ja: '火',
    zh_tw: '二',
    'zh-TW': '二',
  },
  We: {
    en: 'Wed',
    ja: '水',
    zh_tw: '三',
    'zh-TW': '三',
  },
  Th: {
    en: 'Thu',
    ja: '木',
    zh_tw: '四',
    'zh-TW': '四',
  },
  Fr: {
    en: 'Fri',
    ja: '金',
    zh_tw: '五',
    'zh-TW': '五',
  },
  Sa: {
    en: 'Sat',
    ja: '土',
    zh_tw: '六',
    'zh-TW': '六',
  },
}

export const generateTimeOptions = (minHour: number = 0, maxHour: number = 24) => {
  const times = []
  for (let hour = minHour; hour <= maxHour; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      if (hour === maxHour && minute === 30) break
      const formattedHour = hour.toString().padStart(2, '0')
      const formattedMinute = minute.toString().padStart(2, '0')
      times.push(`${formattedHour}:${formattedMinute}`)
    }
  }
  return times
}
